export const en = {
  maintenanceMode: {
    title: "We'll Be Back Soon!",
    description:
      "Our site is currently undergoing maintenance to improve your experience. Thank you for your patience—we'll be back online shortly!",
  },
};
